export { SearchPageSuggestions } from './SearchPageSuggestions';
